<template>
  <div>
    <modal
      :isShow.sync="dialogFormVisible"
      :title="dialogTitles"
      :isShowClose="true"
      :btnText="btnText"
      :isShowBtn="isShowBtn"
      :width="dialogWidth"
    >
      <el-form
        :model="formData"
        label-position="right"
        :label-width="iflabelWidth"
        class="form"
      >
        <el-form-item
          :rules="item.rules === null || '' ? null : item.rules"
          :label="item.label"
          v-for="(item, index) in formDataList"
          :key="index"
          :prop="item.prop"
        >
          <!-- 输入框 -->
          <el-input
            v-model="formData[item.prop]"
            autocomplete="off"
            v-if="item.type === 'input'"
          ></el-input>
          <!-- 文本 -->
          <span v-else-if="item.type === 'text'">{{
            formData[item.prop]
          }}</span>
          <!-- 下拉框 -->
          <el-select
            v-model="formData[item.prop]"
            placeholder=""
            v-else-if="item.type === 'select'"
          >
            <el-option
              v-for="(item, index) in item.selectList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <!-- 描述框 -->
          <el-input
            type="textarea"
            v-model="formData[item.prop]"
            v-else-if="item.type === 'textareas'"
            :maxlength="maxlengths"
            show-word-limit
          ></el-input>
          <!-- 多选框 -->
          <el-checkbox-group
            v-model="formData[item.prop]"
            v-else-if="item.type === 'checkbox'"
          >
            <el-checkbox
              v-for="(item, index) in item.checkboxList"
              :label="item.label"
              :key="index"
            >
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </modal>
  </div>
</template>

<script>
import modal from "./modal";
import Modal from "./modal.vue";
export default {
  components: {
    modal,
  },
  props: {
    dialogTitle: {
      default: () => {
        return "请传入dialogTiele";
      },
      type: String,
    },
    iflabelWidth: {
      default: () => {
        return "80px";
      },
      type: String,
    },
    width: {
      default: () => {
        return "";
      },
      type: String,
    },
    formDatas: {
      default: () => {
        return {};
      },
      type: Object,
    },
    ifdialogFormVisible: {
      default: () => {
        return false;
      },
      type: Boolean,
    },
    formDataLists: {
      default: () => {
        return [];
      },
      // type:Array
    },
    maxlengths: {
      default: () => {
        return "";
      },
      type: String,
    },
  },
  data() {
    return {
      dialogTitles: this.dialogTitle,
      maxlength: this.maxlengths, // 限制文本长度
      labelWidth: this.iflabelWidth, // labe宽度
      dialogWidth: this.width, // 弹框宽度
      formData: this.formDatas, // form表单数据
      dialogFormVisible: this.ifdialogFormVisible, // dialog展示隐藏
      formDataList: this.formDataLists, // 表单label
      btnText: ["取消", "确定"],
      isShowBtn: [true, true],
    };
  },
  methods: {
    ok() {},
  },
  watch: {
    dialogFormVisible: function (newVal, oldVal) {
      this.dialogFormVisible = newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
.form.el-form.form.el-form--label-right {
  padding-left: 40px;
  padding-right: 66px;
}
:deep(.el-input),
:deep(.el-textarea) {
  width: 240px;
}
.el-form :deep(.el-form-item) {
  padding: 5px;
}
:deep(.el-dialog__header) {
  width: 400px;
  height: 46px;
  background: rgba(247, 248, 251, 1);
  border-radius: 4px 4px 0px 0px;
  line-height: 22px;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: rgba(51, 56, 64, 1);
  padding: 0;
}
</style>
